export class SiteSettings {
    isPublicSite: boolean;
}